/**
 * Countdown del credito del cliente mostrato SOLO al professionista durante
 * call/chat a pagamento (evento socket `call:runway`, minuti soltanto — i €
 * del cliente non arrivano mai al client del pro). A ≤3 minuti (CREDIT_LOW_MINUTES,
 * uniforme al countdown lato cliente) il badge passa in warning e compare il
 * banner con l'invito a far ricaricare il cliente (la sessione va in pausa e
 * può riprendere dopo la ricarica).
 */
import { CREDIT_LOW_MINUTES } from '@klaro7/shared-types';

const WARNING_THRESHOLD_MINUTES = CREDIT_LOW_MINUTES;

export function ClientRunwayBadge({ remainingMinutes }: { remainingMinutes: number }) {
  const warning = remainingMinutes <= WARNING_THRESHOLD_MINUTES;
  return (
    <span
      className={
        warning
          ? 'animate-pulse text-sm font-semibold text-amber-400'
          : 'text-sm text-white/70'
      }
    >
      ~{remainingMinutes} min di credito del cliente
    </span>
  );
}

export function ClientRunwayBanner({ remainingMinutes }: { remainingMinutes: number }) {
  if (remainingMinutes > WARNING_THRESHOLD_MINUTES) return null;
  return (
    <div className="mx-auto mb-2 max-w-md animate-pulse rounded-lg bg-amber-500/90 px-3 py-2 text-center text-sm font-semibold text-white">
      ⏳ Credito del cliente in esaurimento — invitalo a ricaricare, la sessione può
      riprendere dopo la pausa.
    </div>
  );
}
